import type { CommentTextSelectionUpdate, CommentType } from '@getaccept/editor-lib';
import type { UpdateCommentsDto } from '@getaccept/lib-shared/src/contextual-commenting/types/update-comments-dto';
import type { UpdateCommentDto } from '@getaccept/lib-shared/src/contextual-commenting/types/update-comment-dto';
import { EditorContentAction } from '../store/editor-content.constants';
import type { UpdateNodeAction } from '../store/types/actions';
import { UpdateCommentsDtoHelper } from './update-comments-dto.helper';

// TODO: One big function for now, but instead of passing in action and requests, we could create different functions for each action
export const getUpdateCommentsDtoForContentUpdate = (
  blockIds: string[],
  allComments: CommentType[],
  updatedTextSelections: { [nodeId: string]: CommentTextSelectionUpdate[] },
  action?: EditorContentAction,
  request?: UpdateNodeAction
): UpdateCommentsDto => {
  const commentsInBlock = UpdateCommentsDtoHelper.getCommentsInBlock(allComments, blockIds);

  if (action === EditorContentAction.UpdateNode) {
    const comments: UpdateCommentDto[] = commentsInBlock.map(({ commentId, editorSelection }) => {
      // comment doesn't have textSelection or is not in targetNode, return as is
      if (
        !editorSelection?.textSelection ||
        editorSelection?.nodeId !== (request as UpdateNodeAction)?.targetNodeId
      ) {
        return { commentId, editorSelection };
      }

      const updatedTextSelection: CommentTextSelectionUpdate = updatedTextSelections[
        editorSelection.nodeId
      ]?.find((selection: CommentTextSelectionUpdate) => selection.id === commentId);

      // comment in targetNode has updated textSelection, return with updated selection
      if (updatedTextSelection) {
        const { ...textSelection } = editorSelection.textSelection;
        delete (textSelection as any).__typename;
        return {
          commentId,
          editorSelection: {
            ...editorSelection,
            textSelection: {
              ...textSelection,
              anchor: updatedTextSelection.from,
              head: updatedTextSelection.to,
            },
          },
        };
      }

      // comment in targetNode, had textSelection but no more, now detachedFromContent
      return {
        commentId,
        editorSelection: {
          ...editorSelection,
          textSelection: undefined,
          detachedFromContent: true,
        },
      };
    });

    return { comments };
  }

  return {
    comments: commentsInBlock,
  };
};
